import DownloadView from '../../features/downloads/components/DownloadView';
import useDownloadResources from '../../features/downloads/composables/useDownloadResources';

function Download() {
    const urlParams = new URLSearchParams(window.location.search);
    const initialDeviceId = urlParams.get('device_id') || '';
    const initialIndexRaw = parseInt(urlParams.get('index') ?? '', 10);
    const initialIndex = Number.isNaN(initialIndexRaw) ? -1 : initialIndexRaw;

    const { state, actions } = useDownloadResources({ initialDeviceId, initialIndex });

    return <DownloadView state={state} actions={actions} />;
}

export default Download;
